import React, { useContext, useState } from 'react';
import cn from 'classnames';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import NotificationCounter from '@wix/da-ds/pkg/Indicators/NotificationCounter';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FakeDrawer from './_partials/FakeDrawer';
import s from './AnonJoinFakeNotification.scss';
var AnonJoinFakeNotification = function (_a) {
    var className = _a.className;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var isMobile = useContext(MobileContext);
    return (React.createElement("div", { className: cn(s['root'], className), onClick: isMobile ? function () { return setIsOpen(!isOpen); } : undefined, onMouseEnter: !isMobile ? function () { return setIsOpen(true); } : undefined, onMouseLeave: !isMobile ? function () { return setIsOpen(false); } : undefined },
        React.createElement(PlainButtonOrLink, { href: isMobile ? undefined : Url.joinLink() },
            React.createElement(NotificationIcon, { className: s['notifications-icon'], size: IconSize.MEDIUM }),
            React.createElement(NotificationCounter, { className: s['counter'] }, "1")),
        React.createElement("div", { role: "dialog", id: "site-header-notifications", className: cn(s['drawer-container'], isOpen && s['active']) }, isOpen && React.createElement(FakeDrawer, null))));
};
AnonJoinFakeNotification.displayName = 'AnonJoinFakeNotification';
export default AnonJoinFakeNotification;
//# sourceMappingURL=AnonJoinFakeNotification.js.map